import React, { useEffect, useRef, useState } from "react";
import { Popup } from "devextreme-react/popup";
import { useScreenSize } from "../../utils/media-query";
import { Button } from "devextreme-react";
import "./CustomOtpPopup.scss";
import { useAuth } from "../../contexts/auth";
import { verifyOtp } from "../../api/forgotPwdApi";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";

const CustomOtpPopup = ({
  visible,
  onClose,
  title = "Verify an OTP",
  height = 250,
  emailOtp,
  setLoading,
  setChkOtpVerify,
}) => {
  const { user } = useAuth();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const length = 6;
  const [timer, setTimer] = useState(60);
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    const combinedOtp = newOtp.join("");
    if (combinedOtp.length === length) onOtpSubmit(combinedOtp);

    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const onOtpSubmit = async (combinedOtp) => {
    try {
      setLoading(true);
      const result = await verifyOtp(emailOtp, "C", combinedOtp);
      if (result?.status === 200 && result?.data) {
        setChkOtpVerify("Y");
        ToastDisplayer("success", result.data.message);
        onClose();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.error || "An unexpected error occurred.",
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (visible) {
      setOtp(new Array(length).fill("")); // ✅ correct reset
    }
  }, [visible]);
  useEffect(() => {
    let interval;

    if (visible) {
      setTimer(60);
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            return prevTimer - 1;
          }
          clearInterval(interval);
          return 0;
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [visible]);

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleRetryClick = async () => {
    try {
      setTimer(60);
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const handlePopupPwdCancel = () => {
    setOtp(new Array(length).fill(""));
    onClose();
  };

  return (
    <Popup
      onShown={() => {
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
      }}
      visible={visible}
      onHiding={onClose}
      height={height}
      width={"auto"}
      showCloseButton={false}
      dragEnabled={false}
      showTitle={false}
      className="import-popup"
    >
      <div className="import-popup-main-container">
        <div className="import-popup-header">
          <div className="import-popup-header-title">
            <div className="header-text">{title}</div>
            <div className="sub-text">
              <div className="resetText">
                Sent to {emailOtp}{" "}
                <span className="notyouText" onClick={handlePopupPwdCancel}>
                  Not you?
                </span>{" "}
              </div>
            </div>
          </div>

          <div className="popup-close-btn">
            <Button icon="close" onClick={handlePopupPwdCancel} />
          </div>
        </div>
        <div>
          <div className="main-container1">
            <div className="otp-main">
              {otp.map((value, index) => (
                <input
                  key={index}
                  type="text"
                  ref={(input) => (inputRefs.current[index] = input)}
                  value={value}
                  onChange={(e) => handleChange(index, e)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="otpInput"
                />
              ))}
            </div>
          </div>

          <div className="footer-main">
            <span className="Pre-text">
              {timer > 0 ? (
                <>
                  Didn't get an OTP ?
                  <span className="boldText">
                    Retry in {minutes.toString().padStart(2, "0")} :{" "}
                    {seconds.toString().padStart(2, "0")}
                  </span>
                </>
              ) : (
                "Didn’t get an OTP ?"
              )}
              {timer === 0 && (
                <span className="resendTxt" onClick={handleRetryClick}>
                  Click here to resend
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default CustomOtpPopup;
